var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAny = function SvgAny(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text)",
    fillRule: "evenodd",
    d: "M.368 1.413C0 2.058 0 2.92 0 4.648v16.704c0 1.727 0 2.59.368 3.235a2.8 2.8 0 0 0 1.045 1.045C2.058 26 2.92 26 4.648 26h30.704c1.727 0 2.59 0 3.235-.368a2.8 2.8 0 0 0 1.045-1.045C40 23.942 40 23.08 40 21.352V4.648c0-1.727 0-2.59-.368-3.235A2.8 2.8 0 0 0 38.587.368C37.942 0 37.08 0 35.352 0H4.648c-1.727 0-2.59 0-3.235.368A2.8 2.8 0 0 0 .368 1.413m23.286 13.801q.3.32.8.32t.8-.32.3-.78-.3-.78-.8-.32-.8.32-.3.78.3.78m3.8 0q.3.32.8.32t.8-.32.3-.78-.3-.78-.8-.32-.8.32-.3.78.3.78m3.8 0q.3.32.8.32t.8-.32.3-.78-.3-.78-.8-.32-.8.32-.3.78.3.78",
    clipRule: "evenodd"
  })));
};
export default SvgAny;